import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';

/** Which controls a trailer's page shows. UX only: the server stays the authority. */
export function useTrailerPermissions() {
  const { state } = useCurrentUser();
  const has = (permission: string) => state.status === 'authenticated' && state.user.permissions.includes(permission);

  return {
    isKnown: state.status === 'authenticated',
    canManage: has('truck.manage'),
    canManageDocuments: has('document.manage'),
    canViewMaintenance: has('maintenance.view'),
  };
}
